import { Component, ViewEncapsulation, OnInit, Input, AfterViewInit, OnDestroy, SimpleChanges, OnChanges, ElementRef, ViewChild } from '@angular/core';
import { PromotionCodeComboBoxModel } from './promotion-code-combo-box.model';
import { GetPromotionCodeListService } from './app-services/get-promotion-code-list.service';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';

/**
 * 共通部品 プロモーションコードコンボボックスを制御するクラス
 *
 * @export PromotionCodeComboBoxComponent
 * @class PromotionCodeComboBoxComponent
 */
@Component({
  selector: 'app-promotion-code-combo-box',
  templateUrl: 'promotion-code-combo-box.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: PromotionCodeComboBoxComponent,
      multi: true
    },
    {
      provide: GetPromotionCodeListService,
      useFactory: (plessHttp: PlessHttp, dialogService: PlessDialogServiceSub) => {
        return new GetPromotionCodeListService(plessHttp, dialogService);
      },
      deps: [PlessHttp, PlessDialogServiceSub]
    }
  ],
  encapsulation: ViewEncapsulation.None
})
export class PromotionCodeComboBoxComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy, ControlValueAccessor {

  public selectedCodeDiv: string = <string>'';
  public selectedCodeValue: string = <string>'';
  public selectedCodeName: string = <string>'';
  public selectedCodeValueName: string = <string>'';
  @Input() public reserve1: string = <string>'';
  public reserve2: string = <string>'';
  public reserveNum1: number = <number>0;
  public reserveNum2: number = <number>0;
  public sortNum: number = <number>0;
  public startOrderCode: string = <string>'';
  public endOrderCode: string = <string>'';
  public model: PromotionCodeComboBoxModel = new PromotionCodeComboBoxModel();
  // 初期データ自動取得フラグ
  public initAutoLoad: boolean = <boolean>true;
  public selectedIndex: number = <number>-1;

  @ViewChild('comboBox', { static: true }) public comboBox: ElementRef;

  @Input() public subid: string = null;
  @Input() blank: boolean = <boolean>true;
  @Input() latestInfo: boolean = <boolean>true;
  @Input() public initFocusItem: any = null;                                    // ロード完了後フォーカスを移動させるid
  @Input() codeDiv: string = <string>'';
  @Input() conReserveNum1: string = <string>'';
  @Input() disabled: boolean = <boolean>false;
  @Input() required: boolean = <boolean>false;
  @Input() isInitCodeDiv: string = <string>'';
  @Input() left: number = <number>10;
  @Input() top: number = <number>10;
  @Input() width: number | string;
  @Input() height: number = <number>20;
  @Input() public tabindex: number = <number>0;
  @Input() visible: boolean = <boolean>true;                                    // 表示・非表示フラグ
  @Input() forcedEnabledMode: string = null;

  /**
   * Creates an instance of PromotionCodeComboBoxComponent.
   * @param {GetPromotionCodeListService} getPromotionCodeListService
   * @memberof PromotionCodeComboBoxComponent
   */
  constructor(
    public elementRef: ElementRef,
    public getPromotionCodeListService: GetPromotionCodeListService,
  ) {}

  // ValueAccessor
  public onChange(_: any) { }
  public onTouched() { }
  public writeValue(text: string): void {
    if (text !== this.selectedCodeValue) {
      this.selectedCodeValue = text;
      this.setCodeValue(text);
    }
  }
  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  /**
   * 初期処理
   *
   * @memberof PromotionCodeComboBoxComponent
   */
  public ngOnInit(): void {
    /** コンボボックスインスタンス設定 */
    this.model.component = this;
    this.comboBox.nativeElement.setAttribute('id', this.subid + '_sub');
    this.comboBox.nativeElement.setAttribute('forcedEnabledMode', this.forcedEnabledMode);
  }

  /**
   * ロード完了時
   *
   * @memberof PromotionInfoComboBoxComponent
   */
  ngAfterViewInit(): void {
    if (this.model.initAutoLoad) {
      // データ取得
      this.getPromotionCodeListService.execute(this.model, this.codeDiv, this.conReserveNum1);
    }
  }

  /**
   * 値変更時イベント
   *
   * @param {SimpleChanges} changes 変更イベント
   * @memberof PromotionCodeComboBoxComponent
   */
  ngOnChanges(changes: SimpleChanges): void {
    Object.keys(changes).forEach((propName) => {
      switch (propName) {
        case 'codeDiv':
          // コード区分
          this.codeDiv = changes.codeDiv.currentValue;
          if (this.model.isInitCodeDiv) {
            this.getPromotionCodeListService.execute(this.model, this.codeDiv, this.conReserveNum1);
          } else {
            this.model.isInitCodeDiv = true;
          }
          break;
        case 'blank':
          /** 先頭空白表示フラグ */
          this.model.blank = changes.blank.currentValue;
          break;
        case 'latestInfo':
          /** 先頭【最新情報】追加フラグ */
          this.model.latestInfo = changes.latestInfo.currentValue;
          break;
        case 'initAutoLoad':
          /** 初期データ自動取得フラグ */
          this.model.initAutoLoad = changes.initAutoLoad.currentValue;
          break;
        case 'reserve1':
            this.reserve1 = changes.reserve1.currentValue;
            this.getPromotionCodeListService.execute(this.model, this.codeDiv, this.reserve1);
      }
    });
  }

  /**
   * コンポーネント終了時
   *
   * @memberof PromotionCodeComboBoxComponent
   */
  ngOnDestroy(): void {
    /** コンボボックス情報初期化 */
    this.clear();
  }

  /**
   * 初期化処理
   *
   * @memberof PromotionCodeComboBoxComponent
   */
  public clear(): void {
    this.selectedCodeDiv = <string>'';
    this.selectedCodeValue = <string>'';
    this.selectedCodeName = <string>'';
    this.selectedCodeValue = <string>'';
    this.reserve1 = <string>'';
    this.reserve2 = <string>'';
    this.reserveNum1 = <number>0;
    this.reserveNum2 = <number>0;
    this.sortNum = <number>0;
    this.startOrderCode = <string>'';
    this.endOrderCode = <string>'';
    this.model = new PromotionCodeComboBoxModel();
    this.model.component = this;
    this.model.blank = this.blank;
    this.model.latestInfo = this.latestInfo;
  }

  /**
   * コンボボックスの選択コードNameを切り替える
   *
   * @param {string} codeValue コード値
   * @memberof PromotionCodeComboBoxComponent
   */
  public setCodeValue(codeValue: string): void {
    this.model.setCodeValue = codeValue;

    // ロード完了の場合
    if (this.model.completeUpdateFlg) {
      this.updateSelectedCodeValue();
    }
  }

  /**
   * コンボボックスの選択コードNameを切り替える
   *
   * @memberof PromotionCodeComboBoxComponent
   */
  updateSelectedCodeValue(): void {
    const codeList: Array<any> = this.model.codeList;
    for (let i = Number(0); i < codeList.length; i++) {
      if (PlessViewUtilsSub.trim(codeList[i].CodeValue) === this.model.setCodeValue) {
        this.selectedIndex = i;
        break;
      }
    }
    // バインドフィールドを更新
    this.updateBindedField(null);
  }

  /**
   * バインドフィールド初期化
   *
   * @private
   * @param {*} e
   * @returns {void}
   * @memberof PromotionCodeComboBoxComponent
   */
  public updateBindedField(e: any): void {
    if (e != null) {
      this.selectedIndex = e.target.selectedIndex;
    }
    if (this.selectedIndex === -1) {
      this.selectedCodeDiv = null;
      this.selectedCodeValue = null;
      this.selectedCodeName = null;
      this.selectedCodeValueName = null;
      this.reserve1 = null;
      this.reserve2 = null;
      this.reserveNum1 = <number>0;
      this.reserveNum2 = <number>0;
      this.sortNum = <number>0;
      this.startOrderCode = null;
      this.endOrderCode = null;

      return;
    }

    this.selectedCodeDiv = this.model.codeList[this.selectedIndex].CodeDiv;
    this.selectedCodeValue = this.model.codeList[this.selectedIndex].CodeValue;
    this.selectedCodeName = this.model.codeList[this.selectedIndex].CodeName;
    this.selectedCodeValueName = this.model.codeList[this.selectedIndex].CodeValueName;
    this.reserve1 = this.model.codeList[this.selectedIndex].Reserve1;
    this.reserve2 = this.model.codeList[this.selectedIndex].Reserve2;
    this.reserveNum1 = this.model.codeList[this.selectedIndex].ReserveNum1;
    this.reserveNum2 = this.model.codeList[this.selectedIndex].ReserveNum2;
    this.sortNum = this.model.codeList[this.selectedIndex].SortNum;
    this.startOrderCode = this.model.codeList[this.selectedIndex].StartOrderCode;
    this.endOrderCode = this.model.codeList[this.selectedIndex].EndOrderCode;
    if (this.initFocusItem != null) {
      let queryedElement;
      if (this.initFocusItem instanceof HTMLElement) {
        queryedElement = this.initFocusItem.querySelector('textarea, input, select');
      } else {
        queryedElement = this.initFocusItem.elementRef.nativeElement.querySelector('textarea, input, select');
      }
      (queryedElement ? <HTMLElement>queryedElement : this.initFocusItem).focus();
    }
  }

  /**
   * コンボボックスの選択Indexを切り替える
   *
   * @param {number} index
   * @memberof PromotionCodeComboBoxComponent
   */
  public setSelectedIndex(index: number): void {
    this.model.setSelectedIndex = index;
    // ロード完了の場合
    if (this.model.completeUpdateFlg) {
      this.updateSelectedIndex();
    }
  }

  /**
   * コンボボックスの選択Indexを切り替える
   *
   * @memberof PromotionCodeComboBoxComponent
   */
  public updateSelectedIndex(): void {
    if (this.model.setSelectedIndex >= 0) {
      this.selectedIndex = <number>this.model.setSelectedIndex;
      this.model.setSelectedIndex = -1;
      this.updateBindedField(null);
    }
  }

}
